import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { CssVarsProvider } from '@mui/joy/styles';
import { CssBaseline } from '@mui/joy';
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate
} from 'react-router-dom';

import './modules/firebase';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import Applications from './components/Applications';
import Applicant from './components/Applicant';
import { UserProvider } from './context/user';

const App = () => {
  return (
    <CssVarsProvider defaultMode="system">
      <CssBaseline />
      <UserProvider>
        <Outlet />
      </UserProvider>
    </CssVarsProvider>
  );
};

const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: <LandingPage />
      },
      {
        path: '/dashboard',
        element: <Dashboard />,
        children: [
          { index: true, element: <Navigate to="applications" replace /> },
          {
            path: 'applications',
            element: <Applications />
          },
          {
            path: 'applications/:applicantId',
            element: <Applicant />
          }
        ]
      }
    ]
  }
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
